import { attachmentRequestKey } from 'utils/administrativoIdempotency';
// src/services/api.js
import axios from 'axios';
import { COMPANY_STORAGE_KEY } from 'types/company.js';

// Configuração dinâmica que funciona com imagens já buildadas
const getApiUrl = () => {
  if (window.API_CONFIG && window.API_CONFIG.API_URL) {
    return window.API_CONFIG.API_URL;
  }

  if (typeof process !== 'undefined' && process.env?.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  const hostname = window.location.hostname;
  const protocol = window.location.protocol;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8080/api';
  }

  return `${protocol}//${hostname}/api`;
};

const API_URL = getApiUrl();

const api = axios.create({
  baseURL: API_URL,
  timeout: 180000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    try {
      const companyContext = localStorage.getItem(COMPANY_STORAGE_KEY);
      if (companyContext) {
        const parsed = JSON.parse(companyContext);
        if (parsed.ids && Array.isArray(parsed.ids) && parsed.ids.length > 0) {
          config.headers['X-Company-Id'] = parsed.ids.join(',');
        }
      }
    } catch (error) {
      console.warn('Erro ao adicionar contexto de empresa:', error);
    }

    if (/\/n8n\/administracao\/a_(pagar|receber)\/novo_arquivo$/.test(config.url || '') && !config.headers['Idempotency-Key']) {
      config.headers['Idempotency-Key'] = await attachmentRequestKey(config.url, config.headers['X-Company-Id'], config.data);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_token_timestamp');
      localStorage.removeItem('dashboard_user');

      if (window.location.pathname !== '/login' && window.location.pathname !== '/') {
        localStorage.setItem('session_expired', 'true');
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default api;
